import { Button, Flex, FlexProps, Icon, IconButton, Text } from '@chakra-ui/react';
import { BiTrashAlt } from 'react-icons/bi';
import { FaArrowLeft } from 'react-icons/fa6';

type Props = FlexProps & {
  showDismissed: boolean;
  toggleShowDismissed: () => void;
};

const NotificationsHeader = ({ showDismissed, toggleShowDismissed, ...props }: Props) => {
  return (
    <Flex
      justifyContent={showDismissed ? 'flex-start' : 'space-between'}
      alignItems="center"
      {...props}
    >
      {showDismissed ? (
        <>
          <IconButton
            aria-label="Show active notifications"
            onClick={toggleShowDismissed}
            icon={<Icon as={FaArrowLeft} boxSize="4" />}
            variant="ghost"
            size="xs"
            mr={2}
          />
          <Text fontSize="16px" fontWeight="bold">
            Dismissed Notifications
          </Text>
        </>
      ) : (
        <>
          <Text fontSize="16px" fontWeight="bold">
            Notifications
          </Text>
          <Button
            variant="link"
            colorScheme="blue"
            leftIcon={<Icon as={BiTrashAlt} boxSize="15px" />}
            fontSize="15px"
            fontWeight="semibold"
            onClick={toggleShowDismissed}
          >
            Dismissed
          </Button>
        </>
      )}
    </Flex>
  );
};

export default NotificationsHeader;
